import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'reload-app-modal',
  templateUrl: './reload-app-modal.component.html',
  styleUrls: ['./reload-app-modal.component.scss']
})
export class ReloadApplicationModalComponent implements OnInit {
  @Input() title: string = '';
  @Input() label: string = '';


  constructor(
    public activeModal: NgbActiveModal) { }

  ngOnInit(): void {

  }

  confirm() {

      this.activeModal.close(true);
  }


  cancel() {
    this.activeModal.dismiss(false);
  }

}
